<div *ngIf="isVisible" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
  <div class="bg-white rounded-lg shadow-xl w-full max-w-2xl p-6">
    <ng-container *ngIf="step === 1">
      <h2 class="text-xl font-bold text-red-700 mb-2">Eliminar proyecto — Impacto</h2>
      <p class="text-sm text-gray-600 mb-4">Revisa todo lo que se eliminará. Esta acción es <b>irreversible</b>.</p>
      <div *ngIf="loading" class="py-8 text-center text-gray-500">Calculando impacto…</div>
      <div *ngIf="!loading && preview">
        <table class="w-full text-sm mb-4">
          <thead><tr class="text-left border-b"><th class="py-1">Tipo</th><th>Cantidad</th><th>Monto</th></tr></thead>
          <tbody>
            <tr *ngFor="let r of preview.impact" class="border-b">
              <td class="py-1">{{ r.entityType }}</td>
              <td>{{ r.count }}</td>
              <td>{{ r.amount != null ? (r.amount | number:'1.0-0') + ' ' + (r.currency || '') : '—' }}</td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="preview.blockers.length" class="bg-red-50 border border-red-300 rounded p-3 mb-4">
          <p class="font-semibold text-red-700 mb-1">No se puede eliminar — bloqueos:</p>
          <ul class="list-disc list-inside text-sm text-red-700">
            <li *ngFor="let b of preview.blockers">{{ b.description }}</li>
          </ul>
        </div>
      </div>
      <div class="flex justify-end gap-2">
        <button class="px-4 py-2 rounded border" (click)="close()">Cancelar</button>
        <button class="px-4 py-2 rounded bg-red-600 text-white disabled:opacity-40" [disabled]="!canContinue" (click)="goStep2()">Continuar</button>
      </div>
    </ng-container>
    <ng-container *ngIf="step === 2 && preview">
      <h2 class="text-xl font-bold text-red-700 mb-2">Confirmación final</h2>
      <div class="bg-red-50 border border-red-300 rounded p-3 mb-4 text-sm text-red-700">
        Esta operación <b>NO se puede deshacer</b>. Se eliminará el proyecto «<b>{{ preview.projectName }}</b>» y todo lo relacionado.
      </div>
      <label class="block text-sm mb-1">Escribe el nombre del proyecto para confirmar:</label>
      <input class="w-full border rounded px-3 py-2 mb-4" [(ngModel)]="typedName" [placeholder]="preview.projectName" autocomplete="off" />
      <div class="flex justify-end gap-2">
        <button class="px-4 py-2 rounded border" (click)="step = 1">Atrás</button>
        <button class="px-4 py-2 rounded bg-red-600 text-white disabled:opacity-40" [disabled]="!nameMatches || starting" (click)="confirmDelete()">
          {{ starting ? 'Iniciando…' : 'Eliminar definitivamente' }}
        </button>
      </div>
    </ng-container>
  </div>
</div>
